import { userService } from '@/_services'
export const user = {
  namespaced: true,
  state: {
    userInfo: null,
    personalData: null,
    authenticationData: null,
    roles: []
  },

  mutations: {
    setPersonalData(state, personalData){
      state.personalData = personalData
    },

    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },

    setAuthenticationData(state, data){
      state.authenticationData = data
    }
  },

  actions: {
    loadPersonalData({ commit }){
      return userService.getMyProfile().then(data => {
        commit('setPersonalData', data)
      })
    },

    loadUser({ commit }) {
      return userService.get().then(data => {
        commit('setUserInfo', data)
      })
    },

    saveProfile({ dispatch }, profile){
      return userService.saveProfile(profile).then(() => {
        dispatch('loadPersonalData')
      })
    },
    
    getRole( { commit } ){
      commit
      return userService.roles().then(data => {
        return data
      })
    }
  },
  
}